module.exports = __webpack_public_path__ + "img/profRec.331ad1f9.svg";